import * as React from 'react';
import { connect } from 'react-redux';

import IState from '../../interfaces/states';

import {
    Widget as WidgetAction,
    WidgetEditor as WidgetEditorAction,
    SaveState as SaveStateAction
} from '../../actions';
import { Widget } from '../../store/models';

import WidgetCanvas from './WidgetCanvas';

interface IProps {
    widgets: Widget[],
    widgetIdInEditor: string,
    editWidget: Function,
    deleteWidget: Function,
    updateWidgets: Function,
    setDirty: Function,
}

function onEdit(widget: Widget, props: IProps) {
    props.editWidget(widget.id);
}

function onDelete(widget: Widget, props: IProps) {
    props.deleteWidget(widget);
    props.setDirty();
}

function onSaveAll(widgets: Widget[], props: IProps) {
    props.updateWidgets(widgets);
    props.setDirty();
}

const WidgetCanvasContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    const { widgets, widgetIdInEditor } = props;

    return (
        <WidgetCanvas
            widgets={widgets}
            widgetIdInEditor={widgetIdInEditor}
            onEdit={(widget: Widget) => onEdit(widget, props)}
            onDelete={(widget: Widget) => onDelete(widget, props)}
            onSaveAll={(widgets: Widget[]) => onSaveAll(widgets, props)} />
    );
}

WidgetCanvasContainer.propTypes = {
    widgets: React.PropTypes.array.isRequired,
    widgetIdInEditor: React.PropTypes.string,
    editWidget: React.PropTypes.func.isRequired,
    deleteWidget: React.PropTypes.func.isRequired,
    updateWidgets: React.PropTypes.func.isRequired,
    setDirty: React.PropTypes.func.isRequired,
};

const mapStateToProps = (state: IState) => {
    const props = {
        widgets: state.reportTemplate.widgets,
        widgetIdInEditor: null,
    }

    const availableWidgets = state.availableWidgets;

    props.widgets.forEach((widget: Widget) => {
        const availableWidget = availableWidgets.filter(aw => aw.type === widget.type)[0] || { color: null, displayName: null };
        widget.color = availableWidget.color;
        widget.displayName = availableWidget.displayName;
    });

    if (state.widgetEditor.open) {
        props.widgetIdInEditor = state.widgetEditor.widgetId;
    }

    return props;
};

export default connect(
    mapStateToProps,
    {
        editWidget: WidgetEditorAction.editWidget,
        deleteWidget: WidgetAction.deleteWidget,
        updateWidgets: WidgetAction.updateWidgets,
        setDirty: SaveStateAction.dirty,
    }
)(WidgetCanvasContainer);


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetCanvasContainer.tsx